import { detect } from 'detect-browser';
import MobileDetect from 'mobile-detect';

export function getBrowser() {
  const browser = detect();

  if (browser) {
    return `${browser.name} ${browser.version}`;
  }

  return undefined;
}

export function getOperatingSystem() {
  const browser = detect();

  if (browser) {
    return browser.os;
  }

  return undefined;
}

export function getDevice(mobileLabel = 'Phone', tabletLabel = 'Tablet', desktopLabel = 'Desktop') {
  if (window) {
    const mobileDetect = new MobileDetect(window.navigator.userAgent);

    if (mobileDetect.tablet()) {
      return tabletLabel;
    }
    if (mobileDetect.mobile() || mobileDetect.phone()) {
      return mobileLabel;
    }

    return desktopLabel;
  }

  return undefined;
}
